var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 4.66634C4.1665 2.54925 5.88275 0.833008 7.99984 0.833008C10.1169 0.833008 11.8332 2.54925 11.8332 4.66634V7.33301C11.8332 9.4501 10.1169 11.1663 7.99984 11.1663C5.88275 11.1663 4.1665 9.4501 4.1665 7.33301V4.66634Z",
    fill: "#3D3D43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81465 6.83301C3.17261 6.83301 3.4628 7.12 3.4628 7.47403C3.4628 9.95223 5.4941 11.9612 7.99984 11.9612C10.5056 11.9612 12.5369 9.95223 12.5369 7.47403C12.5369 7.12 12.8271 6.83301 13.185 6.83301C13.543 6.83301 13.8332 7.12 13.8332 7.47403C13.8332 10.4436 11.5646 12.8892 8.64799 13.2081V13.8843H9.94428C10.3022 13.8843 10.5924 14.1713 10.5924 14.5253C10.5924 14.8793 10.3022 15.1663 9.94428 15.1663H6.05539C5.69743 15.1663 5.40724 14.8793 5.40724 14.5253C5.40724 14.1713 5.69743 13.8843 6.05539 13.8843H7.35169V13.2081C4.43505 12.8892 2.1665 10.4436 2.1665 7.47403C2.1665 7.12 2.45669 6.83301 2.81465 6.83301Z",
    fill: "#3D3D43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicro);
export default __webpack_public_path__ + "static/media/icon-micro.51dd6bf4fd966232f8a96e45a908dcc1.svg";
export { ForwardRef as ReactComponent };